export class PromiseUtil {
    /**
     * Creates a promise that resolves after the specified delay.
     * Useful for adding delays in async functions or waiting for animations/transitions to complete.
     * @param millis The delay in milliseconds before the promise resolves
     * @returns A promise that resolves after the specified delay
     */
    public static delayPromise(millis: number): Promise<any> {
        return new Promise(function (resolve) {
            setTimeout(resolve, millis);
        });
    }
}
